import React from 'react'

import {MapMarker} from '../../../map'
import styleClasses from './classes.module.css'

type Props = Parameters<typeof MapMarker>[0]

export function TariffsMapMarker({children, ...props}: Props) {
  return (
    <MapMarker {...props}>
      <div className={styleClasses.container}>
        <div className={styleClasses.item}>{children}</div>
      </div>
    </MapMarker>
  )
}
